import { spNavClick } from "./spnavclick";

function on($el, type, selector, callback) {
    $el.addEventListener(type, event => {
        if (event.target.closest(selector)) {
            callback(event);
        }
    });
}

function navigationClickEventListener($nav, location, onClick) {
    if (!$nav || !location || typeof onClick !== 'function') {
        throw new Error('navigationClickEventListener expects parameters');
    }

    on($nav, 'click', 'a', event => onClick(event, location));
}

function handleMainNavClick(event, location) {
    let parentList = event.target.closest('ul');

    const categories = [];

    while (parentList) {
        if (parentList.previousElementSibling) {
            categories.push(parentList.previousElementSibling?.innerText);
        } else {
            if (parentList.parentElement?.previousElementSibling?.id === 'nav-global-first-focus-mobile') {
                break;
            }
            categories.push(parentList.parentElement?.previousElementSibling?.firstElementChild?.innerText);
        }

        parentList = parentList.parentElement.closest('ul');
    }

    spNavClick({
        location,
        url: event.target.href,
        category: categories.join('|'),
        selection: event.target.innerText
    });
}

function handleAltNavClick(event, location) {
    const $parentNav = event.target.closest('nav');
    const $text = event.target.querySelector('.text, .sr-only');

    spNavClick({
        location,
        url: event.target.href,
        category: $parentNav.hasAttribute('aria-label') ? $parentNav.getAttribute('aria-label') : '',
        selection: ($text || event.target).innerText
    });
}

export default function navigationClickEventListeners() {
    navigationClickEventListener(document.getElementById('ds-main-nav'), 'mainnav', handleMainNavClick);
    navigationClickEventListener(document.getElementById('nav-account'), 'accountnav', handleAltNavClick);
    navigationClickEventListener(document.getElementById('nav-smartpaks'), 'smartpaksnav', handleAltNavClick);
    navigationClickEventListener(document.getElementById('nav-cart'), 'cartnav', handleAltNavClick);
}